<mat-dialog-content>
	<div class="u-justify-space-between pb-3">
		<h3 mat-dialog-title class="ps-0" i18n>Konfiguration speichern</h3>
		<button mat-icon-button [mat-dialog-close]="undefined">
			<mat-icon fontSet="voest-icons__close" fontIcon="close"></mat-icon>
		</button>
	</div>

	<div *ngIf="data.userInfo$ | async as userInfo" class="row col-lg-6 col-md-8 u-spacer" [formGroup]="configurationRequestForm">
		<mat-form-field class="u-full-width" appearance="outline">
			<mat-label i18n>Speichername</mat-label>
			<input matInput formControlName="name">
		</mat-form-field>

		<div class="mb-3">
			<mat-label class="mb-2 app-equipment-configurator-save-form__label"
								 id="equipment-configurator-save-form__access-level-control">Freigeben für
			</mat-label>

			<mat-radio-group class="u-full-width" formControlName="access"
											 aria-labelledby="equipment-configurator-save-form__access-level-control">
				<mat-radio-button class="col-lg-4 mb-1" value="CREATOR_USER" i18n>Nur für mich</mat-radio-button>
				<mat-radio-button *ngIf="userInfo?.companyName"
													class="equipment-configurator-save-form__access-level-creator-tenant col-lg-4 mb-1"
													value="CREATOR_TENANT"><span i18n>Meine Gruppe</span> ({{userInfo?.companyName}})
				</mat-radio-button>
				<mat-radio-button *ngIf="(canShareGlobally$ | async) === true"
													class="equipment-configurator-save-form__access-level-everyone col-lg-4 mb-1"
													value="EVERYONE">Jeden
				</mat-radio-button>
			</mat-radio-group>
		</div>

		<mat-form-field class="u-full-width" appearance="outline">
			<mat-label i18n>Beschreibung</mat-label>
			<textarea matInput formControlName="description" [cdkTextareaAutosize]="true"></textarea>
		</mat-form-field>
	</div>

	<mat-dialog-actions class="justify-content-end py-3">
		<button mat-flat-button color="primary" [mat-dialog-close]="configurationRequestForm.value" i18n>Speichern</button>
	</mat-dialog-actions>
</mat-dialog-content>
